
<div class="editor-wrapper">
	<div
		ref="editor"
		:style="`min-height: ${minHeight}; max-height: ${maxHeight}; overflow: scroll;`"
		@click="handleClick"
	></div>
</div>
